import { Box, Checkbox, Divider, Flex, Text } from '@chakra-ui/react';
import { FilterTextInput } from '../filterAtoms/ConditionFilterInputs';
import { UseFilterConfigs } from '../useFilterConfigs';

interface FilterSettingsProps
  extends Pick<UseFilterConfigs, 'filterSettings' | 'changeFilterSettings'> {}
export default function FilterAllSettings({
  filterSettings,
  changeFilterSettings,
}: FilterSettingsProps) {
  const { advanceTextSearch } = filterSettings;
  const advanceTextSearchSetting = () => (
    <Checkbox
      variant="circular"
      size="lg"
      isChecked={advanceTextSearch}
      onChange={(e) =>
        changeFilterSettings('advanceTextSearch', !advanceTextSearch)
      }
    >
      <Text fontSize="14px">
        Use ' & ' for AND and ' | ' for OR operations in Text Condition
      </Text>
    </Checkbox>
  );

  // const numberInputSetting = (
  //   key: string,
  //   label: string,
  //   value: number | string | undefined
  // ) => (
  //   <Flex alignItems="center">
  //     <Text fontSize="13px" flex="30%">
  //       {label}
  //     </Text>
  //     <FilterTextInput
  //       disabled={true}
  //       placeholder={label}
  //       title={key}
  //       value={value === undefined ? 'Auto' : value.toString()}
  //       changeValue={changeFilterSettings}
  //     />
  //   </Flex>
  // );
  return (
    <Box p="5px">
      {advanceTextSearchSetting()}
      {/* {numberInputSetting('startRow', 'Start Row', startRow)}
      <Divider my="2" />
      {numberInputSetting('endRow', 'End Row', endRow)}

      <Divider my="2" /> */}

      <Divider my="2" />
    </Box>
  );
}
